import { atom } from 'jotai';

import { organizationDetailQueryAtom } from '../_graphql/queryOrganizationDetail';
import { adminRoutes } from '../routes';

import { atomFromQueryString, atomFromRoutePath } from '~/shared/state';

export type OrganizationDetailTab = 'details' | 'entitlements';

// 🟣🟣🟣 PARAMS
export const $tab = atomFromQueryString.string<OrganizationDetailTab>('tab');
export const $organizationDetailPathParams = atomFromRoutePath(
  adminRoutes.organizationDetails,
);
export const $organizationId = atom(
  (get) => get($organizationDetailPathParams)?.organizationId ?? null,
);

// 🟢🟢🟢 REMOTE DATA
export const $remoteOrganizations = organizationDetailQueryAtom((get) => {
  const organizationId = get($organizationId);

  if (!organizationId) {
    return {
      variables: { organizationId: '' },
      skip: true,
    };
  }

  return {
    variables: { organizationId },
  };
});

// 🟢🟢🟢 COMPUTED DATA
export const $organization = atom((get) => {
  const remote = get($remoteOrganizations);
  return remote.data?.[0] ?? null;
});
